module.exports = __webpack_public_path__ + "static/media/CV_Charlotte_Isambert.1c8d0d24.pdf";